var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generate-test-paper-data-table"},[_c('i-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"border":"","max-height":420}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }